import {
  FETCH_CUSTOMER_TRANSACTION,
  FETCH_FAULTY_CUSTOMER_TRANSACTION,
  FETCH_PRELOADED_CUSTOMER_TRANSACTION,
} from 'actions/customer';

const initialState = {
  isLoading: false,
  customerTransaction: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
  // CDB-1085 - pre-loaded rows keep their own slice so the wallet list state
  // (page/limit/total) is never overwritten when the two tabs are used.
  preloadedTransaction: [],
  preloadedIsLoading: false,
  preloadedPage: 1,
  preloadedLimit: 10,
  preloadedTotalPages: 1,
  preloadedTotal: 0,
};
const customerTransactionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CUSTOMER_TRANSACTION.REQUEST:
    case FETCH_FAULTY_CUSTOMER_TRANSACTION.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_CUSTOMER_TRANSACTION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        customerTransaction: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_FAULTY_CUSTOMER_TRANSACTION.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        customerTransaction: payload,
      };
    }

    case FETCH_PRELOADED_CUSTOMER_TRANSACTION.REQUEST: {
      return { ...state, preloadedIsLoading: true };
    }

    case FETCH_PRELOADED_CUSTOMER_TRANSACTION.SUCCESS: {
      return {
        ...state,
        preloadedIsLoading: false,
        preloadedTransaction: payload.results,
        preloadedPage: payload.page,
        preloadedLimit: payload.limit,
        preloadedTotalPages: payload.totalPages,
        preloadedTotal: payload.totalResults,
      };
    }

    case FETCH_PRELOADED_CUSTOMER_TRANSACTION.FAIL: {
      return { ...state, preloadedIsLoading: false };
    }

    case FETCH_CUSTOMER_TRANSACTION.FAIL:
    case FETCH_FAULTY_CUSTOMER_TRANSACTION.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default customerTransactionReducer;
